import { render, staticRenderFns } from "./problemAnalysis.vue?vue&type=template&id=5d19f27c&scoped=true"
import script from "./problemAnalysis.vue?vue&type=script&lang=js"
export * from "./problemAnalysis.vue?vue&type=script&lang=js"
import style0 from "./problemAnalysis.vue?vue&type=style&index=0&id=5d19f27c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d19f27c",
  null
  
)

export default component.exports